import {
  KnowledgeBaseAssetTypesApi,
  KnowledgeBaseSubsystemsApi,
  KnowledgeBaseComponentClassesApi,
  KnowledgeBaseEventStatesApi,
  KnowledgeBaseParameterNamesApi,
  KnowledgeBaseAssetSubsystemMappingsApi,
  KnowledgeBaseAssetSubsystemComponentClassMappingsApi,
  KnowledgeBaseAssetSubsystemComponentClassComponentTypeMappingsApi,
  KnowledgeBaseComponentTypeApi,
} from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const assetTypesApi = new KnowledgeBaseAssetTypesApi(config);
export const subsystemsApi = new KnowledgeBaseSubsystemsApi(config);
export const componentClassesApi = new KnowledgeBaseComponentClassesApi(config);
export const eventStatesApi = new KnowledgeBaseEventStatesApi(config);
export const parameterNamesApi = new KnowledgeBaseParameterNamesApi(config);
export const componentTypeApi = new KnowledgeBaseComponentTypeApi(config);
export const assetSubsystemMappingsApi =
  new KnowledgeBaseAssetSubsystemMappingsApi(config);
export const assetSubsystemComponentClassMappingsApi =
  new KnowledgeBaseAssetSubsystemComponentClassMappingsApi(config);
export const assetSubsystemComponentClassComponentTypeMappingsApi =
  new KnowledgeBaseAssetSubsystemComponentClassComponentTypeMappingsApi(config);
